var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTypescript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 199.62 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M199.62,16.8v166.41c-.14.41-.3.82-.41,1.24-1.79,7.37-6.26,12.29-13.44,14.71-.96.32-1.95.56-2.92.84H16.78c-.1-.08-.18-.21-.29-.24C5.23,196.89.01,190.15.01,178.46c0-33.37,0-66.75,0-100.12,0-19.45-.04-38.9.02-58.35C.06,11.49,4.04,5.36,11.66,1.69,13.27.92,15.07.55,16.78,0c55.36,0,110.72,0,166.08,0,.29.12.56.29.86.35,5.33,1.03,9.67,3.74,12.51,8.33,1.52,2.46,2.29,5.39,3.4,8.11ZM123.59,159.21c0,5.79,0,11.13,0,16.46,0,3.25-.02,3.32,3.03,4.37,12.56,4.35,25.35,4.92,38.13,1.39,9.21-2.55,16.03-8.11,17.93-18.05,1.91-10.01-.39-18.77-8.8-25.22-2.05-1.57-4.27-2.99-6.58-4.14-4.23-2.12-8.6-3.97-12.88-5.99-3.23-1.53-6.45-3.11-8.75-6.02-2.71-3.43-2.27-7.71,1.26-10.29,1.43-1.05,3.16-1.85,4.87-2.32,6.21-1.69,12.39-.96,18.42.94,3.11.98,6.05,2.48,9.17,3.79,0-5.35-.06-10.74.04-16.13.03-1.4-.49-1.93-1.73-2.29-12.06-3.53-24.19-4.02-36.27-.34-7.57,2.31-13.59,6.78-16.64,14.43-4.43,11.12-.39,23.4,10.28,29.99,4.77,2.95,10.17,4.84,15.15,7.48,3.35,1.78,6.84,3.61,9.6,6.14,4.53,4.15,3.32,10.03-2.2,12.77-.92.46-1.91.82-2.91,1.06-5.76,1.4-11.47.94-17.12-.62-5.06-1.4-9.56-3.9-13.99-7.41ZM90.87,182.37v-71.52h24.83v-15.8H46.16v15.98h24.84v71.35h19.86Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypescript);
export default __webpack_public_path__ + "static/media/typescript.0cba54f6f0e9fd05ccdd53519cf006e4.svg";
export { ForwardRef as ReactComponent };